function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import GridParagraphWithImageFieldsConfig from "segments/desktop/core-components/grid-paragraph-with-image/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";
import { BACKGROUND_COLOR_OPTIONS } from "segments/segments-service";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
const backLayer = {
    type: FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Card back layer",
    conditionalKeyName: "enable",
    options: [
        {
            text: "True",
            fieldsConfig: GridParagraphWithImageFieldsConfig
        }
    ]
};
export default {
    type: FIELD_TYPES.NESTED,
    label: "Sliding Card",
    fields: _object_spread_props(_object_spread({}, ThemeConfig), {
        cardsToShow: {
            type: FIELD_TYPES.TEXT,
            label: "Number of cards to show in view"
        },
        cardColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Card color",
            possibleColors: [
                ...BACKGROUND_COLOR_OPTIONS,
                "transparent"
            ]
        },
        carouselTitle: {
            type: FIELD_TYPES.NESTED,
            label: "Title with arrows",
            fields: _object_spread_props(_object_spread({}, TitleConfig), {
                marginBottom: {
                    type: FIELD_TYPES.TEXT,
                    label: "Margin bottom"
                },
                withArrows: {
                    type: FIELD_TYPES.BOOLEAN,
                    label: "With arrows"
                }
            })
        },
        cardInnerPadding: {
            type: FIELD_TYPES.TEXT,
            label: "Card paragraph padding"
        },
        isFullScreen: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Is full screen"
        },
        borderColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Border color",
            possibleColors: [
                ...BACKGROUND_COLOR_OPTIONS,
                "transparent"
            ]
        },
        arrowsColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Arrows color"
        },
        backgroundHoverColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Background hover color",
            possibleColors: [
                ...BACKGROUND_COLOR_OPTIONS
            ]
        },
        cards: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                label: "Sliding Card",
                fields: _object_spread_props(_object_spread({}, GridParagraphWithImageFieldsConfig), {
                    backLayer
                })
            }
        },
        autoplay: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Autoplay"
        },
        autoplaySpeed: {
            type: FIELD_TYPES.TEXT,
            label: "Autoplay Speed"
        },
        infinite: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Infinite"
        },
        imageOnTop: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Card Image On Top"
        },
        arrowDesignType: {
            type: FIELD_TYPES.COMBO,
            label: "Arrow Design Type",
            options: [
                {
                    value: undefined,
                    text: "Arrows on bottom middle"
                },
                {
                    value: "arrows-on-top-right",
                    text: "Arrows on top right"
                }
            ]
        },
        arrowsTopOffset: {
            type: FIELD_TYPES.TEXT,
            label: "Arrows top offset"
        },
        topRightArrowColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Top right arrows color (icon and stroke)"
        }
    })
};
